import React, { Component } from 'react';
import { withRouter } from '../withRouter.js';
import api from '../services/api.js';
import apiString from '../services/apiString.js';
import apiStringServer from '../services/apiStringServer.js';

import theme from './themes/Theme';
import { ThemeProvider } from '@mui/material';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Send from '@mui/icons-material/Send';

class Process extends Component {

  state = {
    user: '',
    user_id: '',
    process_id: '',
    process: [],
    process_files: [],
    progress: [],
    observations: '',

    selected_city: '',

    row: true,
  }

  async componentDidMount() {

    if (this.props.location.state) {
      await this.setState({ process_id: this.props.location.state.fields.process_id });
      await this.setState({ user: this.props.location.state.fields.user });
      await this.setState({ selected_city: this.props.location.state.fields.selected_city });
    } else {
      const idx = document.URL.indexOf('?');

      var params = [];
      if (idx !== -1) {
        var pairs = document.URL.substring(idx + 1, document.URL.length).split('&');
        //alert(pairs);
        for (var i = 0; i < pairs.length; i++) {
          let nameVal = pairs[i].split(',');
          nameVal = pairs[i].replace('process_id=', '');
          nameVal = pairs[i].replace('user=', '');
          nameVal = pairs[i].replace('selected_city=', '');
          params.push(nameVal);
        }
      }

      await this.setState({ process_id: decodeURI(params[0]) });
      await this.setState({ user: decodeURI(params[1]) });
      await this.setState({ selected_city: decodeURI(params[2]) });
    }

    if (navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i)
    ) {
      this.setState({ row: false });
    } else {
      this.setState({ row: true });
    }

    await this.setState({ process_id: this.state.process_id.replace('process_id=', '') });
    await this.setState({ user_id: this.state.user.replace('user=', '') });

    try {
      let resp = await api.get('/oneprocess', {
        params: {
          process_id: this.state.process_id,
          selected_city: this.state.selected_city
        }
      });
      if (resp != null) {
        if (resp.data) {
          if (JSON.stringify(resp.data).includes('protocol')) {

            this.setState({ process: resp.data });

            if (this.state.user !== '' || this.state.user !== undefined) {
              await this.setState({ user_id: this.state.user });
            } else {
              await this.setState({ user_id: resp.data[0].user_id });
            }

          } else {
            let msg = JSON.stringify(resp.data);
            alert(msg);
          }
        }
      }
    } catch (err) {
      alert('Não foi possível buscar os dados do processo. ' + err);
    }

    try {
      let resp = await api.get('/processfiles', {
        params: {
          process_id: this.state.process_id,
          selected_city: this.state.selected_city
        }
      });
      if (resp != null) {
        if (resp.data) {
          if (JSON.stringify(resp.data).includes('file')) {

            this.setState({ process_files: resp.data });

          } else {
            let msg = JSON.stringify(resp.data);
            alert(msg);
          }
        }
      }
    } catch (err) {
      alert('Não foi possível buscar os arquvios do processo. ' + err);
    }

    try {
      let resp = await api.get('/progress', {
        params: {
          process_id: this.state.process_id,
          selected_city: this.state.selected_city,
        }
      });
      if (resp != null) {
        if (resp.data) {
          if (JSON.stringify(resp.data).includes('progress')) {

            this.setState({ progress: resp.data });

          } else {
            let msg = JSON.stringify(resp.data);
            //alert(msg);
          }
        }
      }
    } catch (err) {
      alert('Não foi possível buscar os dados do andamento do processo. ' + err);
    }

  }

  handleSend = async () => {

    if (this.state.observations === '') {
      alert('Preencha o campo de observações.');
    } else {
      try {
        let resp = await api.post('/progress', {
          user_id: this.state.user_id,
          process_id: this.state.process_id,
          selected_city: this.state.selected_city,
          observations: this.state.observations,
        });
        if (resp != null) {
          if (resp.data) {
            if (JSON.stringify(resp.data).includes('registred')) {
              this.componentDidMount();
            } else {
              let msg = JSON.stringify(resp.data);
              alert(msg);
            }
          }
        }
      } catch (err) {
        alert('Não foi possível enviar as observações. ' + err);
      }
    }
  }

  handleChange = async e => {
    await this.setState({ [e.target.name]: e.target.value });
  }

  render() {

    return (

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        margin: -10,
      }}
      >

        <ThemeProvider theme={theme}>

          {this.state.row ? (

            <Box sx={{
              backgroundColor: '#E5E6F0',
              height: window.innerHeight
            }}
            >
              <div style={styles.directionRow}>
                <Container maxWidth="lg" style={styles.container}>
                  {this.state.process.map((item) =>
                    <Typography variant="h6" color="textSecondary" align="left">
                      <div>
                        Nome: {item.process_name}
                      </div>
                      <div>
                        Nº de Referência: {item.process_number}
                      </div>
                      <div>
                        Protocolo: {item.protocol}
                      </div>
                      <div>
                        {item.secretary_name}
                      </div>
                      <div>
                        Subcategoria: {item.subcategory_name}
                      </div>
                      <div>
                        Tema: {item.theme}
                      </div>
                      <div>
                        Sub-Tema: {item.subtheme}
                      </div>
                      <div>
                        Descrição: {item.description}
                      </div>
                      <div>
                        Endereço: {item.street}, {item.number} - {item.complement !== 'undefined' ? item.complement : '(sem complemento)'},
                        {' '}{item.district}, {item.city} - {item.state}
                      </div>
                      <div>
                        Remetente: {item.user_name}
                      </div>
                      <div>
                        E-mail do remetente: {item.email}
                      </div>
                    </Typography>
                  )}
                </Container>

                {this.state.process_files ? (
                  <Container maxWidth="lg" style={styles.container}>
                    <Typography variant="h6" color="textSecondary" align="left">
                      <div>
                        Arquivos
                      </div>
                    </Typography>
                    {this.state.process_files.map((item) =>
                      <Typography variant="h6" color="textSecondary" align="left">
                        <a target="_blank" rel="noreferrer" href={`${apiStringServer}/documents/${item.file}`}>
                          <Typography variant="subtitle1" color="textSecondary" align="left">
                            {item.file}
                          </Typography>
                        </a>
                      </Typography>
                    )}
                  </Container>
                ) : null}
              </div>

              <Container maxWidth="lg" style={styles.container}>
                <Typography variant="h6" color="textSecondary" align="left">
                  <div>
                    Andamento
                  </div>
                </Typography>
                <TextField
                  id="observations"
                  name="observations"
                  label="Observações"
                  multiline
                  value={this.state.observations}
                  style={{ margin: 10, width: '50%' }}
                  variant="outlined"
                  onChange={this.handleChange}
                />
                <Button
                  variant="contained"
                  color="primary"
                  style={{ margin: 20, textTransform: 'none' }}
                  onClick={this.handleSend}
                >
                  <Send />
                </Button>
                {this.state.progress.map((item) =>
                  <Typography variant="subtitle1" color="textSecondary" align="left">
                    {item.user_name}: {item.message}
                  </Typography>
                )}
              </Container>
            </Box>

          ) : (
            <Box sx={{
              backgroundColor: '#E5E6F0',
              height: window.innerHeight
            }}
            >
              <div style={styles.directionColumn}>
                <Container maxWidth="lg" style={styles.container}>
                  {this.state.process.map((item) =>
                    <Typography variant="subtittle1" color="textSecondary" align="left">
                      <div>
                        Protocolo: {item.protocol}
                      </div>
                      <div>
                        {item.secretary_name}
                      </div>
                      <div>
                        Subcategoria: {item.subcategory_name}
                      </div>
                      <div>
                        Endereço: {item.street}, {item.number} - {item.complement !== 'undefined' ? item.complement : '(sem complemento)'},
                        {' '}{item.district}, {item.city} - {item.state}
                      </div>
                      <div>
                        Remetente: {item.user_name}
                      </div>
                      <div>
                        E-mail do remetente: {item.email}
                      </div>
                    </Typography>
                  )}
                </Container>

                {this.state.process_files ? (
                  <Container maxWidth="lg" style={styles.container}>
                    <Typography variant="h6" color="textSecondary" align="left">
                      <div>
                        Arquivos
                      </div>
                    </Typography>
                    {this.state.process_files.map((item) =>
                      <Typography variant="h6" color="textSecondary" align="left">
                        <a target="_blank" rel="noreferrer" href={`${apiStringServer}/documents/${item.file}`}>
                          <Typography variant="subtitle1" color="textSecondary" align="left">
                            {item.file}
                          </Typography>
                        </a>
                      </Typography>
                    )}
                  </Container>
                ) : null}
              </div>

              <Container maxWidth="lg" style={styles.container}>
                <Typography variant="h6" color="textSecondary" align="left">
                  <div>
                    Andamento
                  </div>
                </Typography>
                <TextField
                  id="observations"
                  name="observations"
                  label="Observações"
                  multiline
                  value={this.state.observations}
                  style={{ margin: 10, width: '50%' }}
                  variant="outlined"
                  onChange={this.handleChange}
                />
                <Button
                  variant="contained"
                  color="primary"
                  style={{ margin: 20, textTransform: 'none' }}
                  onClick={this.handleSend}
                >
                  <Send />
                </Button>
                {this.state.progress.map((item) =>
                  <Typography variant="subtitle1" color="textSecondary" align="left">
                    {item.user_name}: {item.message}
                  </Typography>
                )}
              </Container>
            </Box>
          )}

        </ThemeProvider>

      </div>

    );

  }

}

let styles = {

  container: { 
    margin: 15, 
    backgroundColor: '#bfcadb',
    borderRadius: 5,
    padding: 5,
  },

  directionRow: {
    display: 'flex',
    flexDirection: 'row'
  },

  directionColumn: {
    display: 'flex',
    flexDirection: 'column'
  },

}

export default withRouter(Process);